import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  content
}: ModalProps) {
  return createPortal(<AnimatePresence data-id="element-273">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-[9998] backdrop-blur-sm" data-id="element-274" />
        
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none" data-id="element-275">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="w-full max-w-2xl bg-white rounded-lg shadow-2xl max-h-[85vh] flex flex-col pointer-events-auto" data-id="element-276">
            
              <div className="flex items-center justify-between p-6 border-b border-gray-100 flex-shrink-0" data-id="element-277">
                <h3 className="text-xl font-heading font-bold text-gray-900" data-id="element-278">
                  {title}
                </h3>
                <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-279">
                
                  <X className="h-5 w-5 text-gray-500" data-id="element-280" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto" data-id="element-281">
                <div className="prose prose-red max-w-none text-gray-600 space-y-4" data-id="element-282">
                  {content}
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>, document.body);
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Политика конфиденциальности" content={<>
          <p data-id="element-284">
            <strong data-id="element-285">1. Общие положения</strong>
          </p>
          <p data-id="element-286">
            Настоящая политика обработки персональных данных составлена в
            соответствии с требованиями законодательства Кыргызской Республики и
            определяет порядок обработки персональных данных и меры по
            обеспечению безопасности персональных данных, предпринимаемые ОсОО
            «Явуз Бурак» (далее – Оператор).
          </p>
          <p data-id="element-287">
            <strong data-id="element-288">2. Основные понятия</strong>
          </p>
          <p data-id="element-289">
            Персональные данные – любая информация, относящаяся прямо или
            косвенно к определенному или определяемому пользователю веб-сайта.
          </p>
          <p data-id="element-290">
            <strong data-id="element-291">3. Цели обработки</strong>
          </p>
          <p data-id="element-292">
            Целью обработки персональных данных Пользователя является
            информирование Пользователя посредством отправки электронных писем;
            заключение, исполнение и прекращение гражданско-правовых договоров;
            предоставление доступа Пользователю к сервисам, информации и/или
            материалам, содержащимся на веб-сайте.
          </p>
          <p data-id="element-293">
            <strong data-id="element-294">4. Правовые основания</strong>
          </p>
          <p data-id="element-295">
            Оператор обрабатывает персональные данные Пользователя только в
            случае их заполнения и/или отправки Пользователем самостоятельно
            через специальные формы, расположенные на сайте. Заполняя
            соответствующие формы и/или отправляя свои персональные данные
            Оператору, Пользователь выражает свое согласие с данной Политикой.
          </p>
          <p data-id="element-296">
            <strong data-id="element-297">5. Cookies</strong>
          </p>
          <p data-id="element-298">
            Сайт использует файлы cookie для улучшения пользовательского опыта и
            анализа трафика. Файлы cookie не содержат персональных данных. Вы
            можете отключить использование cookie в настройках вашего браузера.
          </p>
        </>} data-id="element-283" />;
}
export function TermsModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Условия использования" content={<>
          <p data-id="element-300">
            <strong data-id="element-301">1. Введение</strong>
          </p>
          <p data-id="element-302">
            Добро пожаловать на сайт компании ОсОО «Явуз Бурак». Используя этот
            сайт, вы соглашаетесь соблюдать следующие условия использования.
          </p>
          <p data-id="element-303">
            <strong data-id="element-304">2. Интеллектуальная собственность</strong>
          </p>
          <p data-id="element-305">
            Весь контент на этом сайте, включая текст, графику, логотипы,
            изображения и программное обеспечение, является собственностью ОсОО
            «Явуз Бурак» и защищен законами об авторском праве.
          </p>
          <p data-id="element-306">
            <strong data-id="element-307">3. Использование сайта</strong>
          </p>
          <p data-id="element-308">
            Вы соглашаетесь использовать сайт только в законных целях и таким
            образом, который не нарушает права других лиц, не ограничивает и не
            препятствует использованию и пользованию сайтом кем-либо другим.
          </p>
          <p data-id="element-309">
            <strong data-id="element-310">4. Ограничение ответственности</strong>
          </p>
          <p data-id="element-311">
            ОсОО «Явуз Бурак» не несет ответственности за любые убытки или
            ущерб, возникшие в результате использования данного сайта или
            информации, содержащейся на нем.
          </p>
          <p data-id="element-312">
            <strong data-id="element-313">5. Изменения условий</strong>
          </p>
          <p data-id="element-314">
            Мы оставляем за собой право изменять эти условия в любое время. Ваше
            дальнейшее использование сайта после внесения изменений означает
            ваше согласие с новыми условиями.
          </p>
        </>} data-id="element-299" />;
}